<template>
  <form class="k-form" :aria-labelledby="title ? 'form-title' : null">
    <h3 v-if="title" id="form-title">{{ title }}</h3>
    <div class="k-form-content" :style="{ '--form-columns': columns }">
      <slot></slot>
    </div>
  </form>
</template>

<style scoped>
.k-form h3 {
  margin-bottom: 16px;
}

.k-form-content {
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(var(--form-columns, 1), 1fr);
}

/* Responsive breakpoints */
@media (max-width: 768px) {
  .k-form-content {
    grid-template-columns: 1fr;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .k-form-content {
    grid-template-columns: repeat(min(var(--form-columns, 1), 2), 1fr);
  }
}
</style>

<script>
export default {
  name: 'KForm',
  props: {
    title: {
      type: String,
      default: '',
    },
    columns: {
      type: Number,
      default: 1,
    },
  },
};
</script>
